import { Component, EventEmitter, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { faArrowRightFromBracket, faBars, faUser, faRightFromBracket, faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MenuModule } from 'primeng/menu';
import { SharedModule } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DEPARTMENTS_TYPES } from '../../constants/client.constants';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [FontAwesomeModule, MenuModule, SharedModule, CommonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  /** El estado abierto/cerrado lo guarda el layout (única fuente de verdad): el header solo avisa del clic. */
  @Output() menuToggled = new EventEmitter<void>();

  faArrowRightFromBracket = faArrowRightFromBracket;
  faUser = faUser;
  faRightFromBracket = faRightFromBracket;
  headerTitle = '';
  items: any[] = [
    {label: 'Mi perfil', faIcon: faUser, command: () => this.goToProfile()},
    {separator: true},
    {label: 'Salir', faIcon: faRightFromBracket, command: () => this.logout()}
  ];
  faBars = faBars;
  faChevronDown = faChevronDown;
  departmentsTypes = DEPARTMENTS_TYPES;

  constructor(
    public authService: AuthService,
    private router: Router
  ) {
    this.updateHeader();
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd), takeUntilDestroyed())
      .subscribe(() => this.updateHeader());
  }

  get userName(): string {
    return this.authService.getUser()?.user.name ?? '';
  }

  get initials(): string {
    return this.userName.trim().split(/\s+/).slice(0, 3).map(w => w[0]?.toUpperCase() ?? '').join('') || '?';
  }

  get department(): string | undefined {
    const dep = this.authService.getUser()?.user.department;
    return this.departmentsTypes.find(d => d.value === dep)?.label;
  }

  private updateHeader() {
    let route = this.router.routerState.snapshot.root;
    while (route.firstChild) route = route.firstChild;
    const title = route.data['title'];
    this.headerTitle = title ? `Gestor de campañas: ${title}` : '';
  }

  toggleMenu() {
    this.menuToggled.emit();
  }

  goToProfile() {
    const userId = this.authService.getUserId();
    if (userId) {
      this.router.navigate(['/users/detail', userId]);
    }
  }

  logout() {
    void this.authService.logout();
  }
}
